import Link from 'next/link';
import { MenuItem, MenuList, Paper } from '@mui/material';
import { LegalMenuItem } from './legalMenuItems';

export const LegalDocsMenu = ({
  menuItems,
}: {
  menuItems: LegalMenuItem[];
}) => {
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}
    >
      <MenuList>
        {menuItems.map((item) => (
          <Link
            key={item.title}
            href={item.url}
            style={{ textDecoration: 'none' }}
          >
            <MenuItem>{item.title}</MenuItem>
          </Link>
        ))}
      </MenuList>
    </Paper>
  );
};
